import Vue from "vue";
import CommaInput from "@/components/CommaInput.vue";
import MaxLengthInput from "@/components/MaxLengthInput.vue";
import MaxLengthTextarea from "@/components/MaxLengthTextarea.vue";
import MaxLengthEditor from "@/components/MaxLengthEditor.vue";
import HyphenInput from "@/components/HyphenInput.vue";
import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";

Vue.component("CommaInput", CommaInput);
Vue.component("MlInput", MaxLengthInput);
Vue.component("MlTextarea", MaxLengthTextarea);
Vue.component("MlEditor", MaxLengthEditor);
Vue.component("HyphenInput", HyphenInput);
Vue.component("RadioTypeCheck", RadioTypeCheck);
